<template>
  <div class="lock-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page lock-page section-image" filter-color="black">
        <!--   you can change the color of the filter page using: data-color="blue | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card type="lock" class="text-center">
                <img slot="header" src="static/img/central-gym150x150.webp" alt="CentralGym logo" />
                <h4 class="card-title">{{ this.username }}</h4>
                <h6 class="card-subtitle mb-2 text-muted">{{ this.email }}</h6>
                <fg-input
                  type="password"
                  placeholder="Contraseña ..."
                  v-model="form.password"
                ></fg-input>
                <p-button
                  @click="unLock"
                  slot="footer"
                  type="default"
                  round
                  outline
                >
                  Desbloquear
                </p-button>
              </card>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/bruno-abatti.jpg)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
import { Card, Button, FgInput } from "src/components/UIComponents";
import axios from "axios";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    FgInput,
    [Button.name]: Button,
  },
  methods: {
    showSwal(mensajeServicio, CodigoHTTP) {
      new swal({
        title: `ERROR: ${CodigoHTTP}`,
        text: mensajeServicio,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-success btn-fill",
      });
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    unLock() {
      // let userDataToJSON = JSON.parse(sessionStorage.getItem("username"));
      // let userSession = userDataToJSON.usuarioSesion;
      let userSession = sessionStorage.getItem("WHbUjdv3TG");
      // console.log(userSession);

      this.$axiosLogin
        .post(this.$Operations.Login, {
          Header: {
            Operacion: this.$Operations.Login,
          },
          Body: {
            idAplicacion: this.$store.getters.getAPPId,
            usuarioSesion: this.username,
            password: this.form.password,
          },
        })
        .then((result) => {
          let response = result.data.Response;
          if (
            response.Resultado.CodigoHTTP === 200 ||
            response.Resultado.CodigoHTTP === 201
          ) {
            sessionStorage.removeItem("isLocked");
            this.$router.push("/");
          } else {
            console.error("ERROR");
          }
        })
        .catch((err) => {
          let mensajeServicio =
            err.response.data.Response.Resultado.MensajeServicio;
          let CodigoHTTP = err.response.data.Response.Resultado.CodigoHTTP;
          this.showSwal(mensajeServicio, CodigoHTTP);
        });
    },
  },
  data() {
    return {
      form: {
        password: "",
      },
      username: sessionStorage.getItem("WHbUjdv3TG") || "No User",
      email: sessionStorage.getItem("email") || "No Email",
    };
  },
  beforeCreate() {
    sessionStorage.setItem("isLocked", true);
  },
  beforeDestroy() {
    this.closeMenu();
  },
};
</script>
<style></style>
